const state = {
  minimized: false,
  heatmap: false
}

const mutations = {
  setMinimized: (state, { minimized }) => {
    state.minimized = minimized
  },
  toggleHeatmap: (state) => {
    state.heatmap = !state.heatmap
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
